import React, { useState } from 'react'

export default function Safety() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <section className="py-12 px-6 md:px-12 lg:px-20 bg-white animate-on-scroll">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center justify-between p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all"
          style={{ borderLeft: '4px solid var(--medispa-olive)' }}
        >
          <h2 className="text-2xl md:text-3xl font-light text-[#2c3424]">
            Sigurnost i za koga tretman nije prikladan
          </h2>
          <svg
            className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`}
            style={{ color: 'var(--medispa-olive)' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        
        {isOpen && (
          <div className="mt-6 space-y-8 animate-fadeIn">
            {/* Is it Safe */}
            <div className="bg-white p-6 rounded-lg border border-gray-200">
              <h3 className="text-xl font-light mb-4 text-[#2c3424]">Je li lasersko uklanjanje dlačica sigurno?</h3>
              <p className="text-[#1a1a1a] mb-3">
                Da. DEKA Again je <strong>medicinski sustav</strong> koji se koristi u klinikama širom svijeta:
              </p>
              <ul className="space-y-2 text-[#1a1a1a] ml-6">
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Kontrolirana isporuka energije</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Integrirano hlađenje za zaštitu kože</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Sigurno za različite tipove kože</span>
                </li>
              </ul>
            </div>

            {/* Who is Not Suitable */}
            <div className="bg-white p-6 rounded-lg border border-gray-200">
              <h3 className="text-xl font-light mb-4 text-[#2c3424]">Za koga tretman nije prikladan?</h3>
              <p className="text-[#1a1a1a] mb-3">
                Tretman možda nije prikladan ako:
              </p>
              <ul className="space-y-2 text-[#1a1a1a] ml-6">
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Ste trudni/trudnica</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Imate određena kožna stanja</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Koristite fotosenzibilizirajuće lijekove</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Imate aktivne kožne infekcije</span>
                </li>
              </ul>
              <p className="text-[#1a1a1a] font-medium mt-4 text-sm">
                Zato su konzultacije ključne prije tretmana.
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}